import ErrorLabel from 'modules/host-personalized-offer/components/ErrorLabel';
import React from 'react';

const ErrorList = ({ errors }) => {
  if (!errors) {
    return null;
  }

  const errorMessages = Object.keys(errors).map((key) => (
    <li key={key}>{errors[key]}</li>
  ));

  return (
    <ErrorLabel>
      <ul>{errorMessages}</ul>
    </ErrorLabel>
  );
};

export default ErrorList;
